import DataObjectField from '@/utilities/classes/data-object-field';

const buildLandlordResubmissionDataObject = (vData)  => {

  const fields = [];

  if(vData.Landlord.RentalLicenseNumber != null){
    fields.push(new DataObjectField(vData.Landlord.RentalLicenseNumber, 18));
  }
  if(vData.Landlord.ContactInformation.FirstName != null){
    fields.push(new DataObjectField(vData.Landlord.ContactInformation.FirstName, 19));
  }
  if(vData.Landlord.ContactInformation.LastName != null){
    fields.push(new DataObjectField(vData.Landlord.ContactInformation.LastName, 20));
  }
  if(vData.Landlord.ContactInformation.CellPhone != null){
    fields.push(new DataObjectField(vData.Landlord.ContactInformation.CellPhone, 22));
  }
  if(vData.Landlord.ContactInformation.EmailAddress != null){
    fields.push(new DataObjectField(vData.Landlord.ContactInformation.EmailAddress, 21));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.FirstName != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.FirstName, 31));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.LastName != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.LastName, 32));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.CellPhone != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.CellPhone, 34));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.EmailAddress != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.EmailAddress, 33));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepFirstName != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.MediationRepFirstName, 658));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepLastName != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.MediationRepLastName, 659));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepPhone != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.MediationRepPhone, 661));
  }
  if(vData.PropertyManagementRepresentative.ContactInformation.MediationRepEmail != null){
    fields.push(new DataObjectField(vData.PropertyManagementRepresentative.ContactInformation.MediationRepEmail, 660));
  }
  if(vData.Tenant.ContactInformation.FirstName != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.FirstName, 6));
  }
  if(vData.Tenant.ContactInformation.LastName != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.LastName, 7));
  }
  if(vData.Tenant.ContactInformation.CellPhone != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.CellPhone, 8));
  }
  if(vData.Tenant.ContactInformation.EmailAddress != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.EmailAddress, 9));
  }
  if(vData.Tenant.ContactInformation.SecondaryFirstName != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.SecondaryFirstName, 104));
  }
  if(vData.Tenant.ContactInformation.SecondaryLastName != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.SecondaryLastName, 105));
  }
  if(vData.Tenant.ContactInformation.SecondaryCellPhone != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.SecondaryCellPhone, 107));
  }
  if(vData.Tenant.ContactInformation.SecondaryEmailAddress != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.SecondaryEmailAddress, 106));
  }
  if(vData.Arrears != null){
    fields.push(new DataObjectField(vData.Arrears, 65));
  }
  if(vData.WithdrawTFA == "Yes"){
    fields.push(new DataObjectField(true, 723));
  }
  if(vData.Tenant.ContactInformation.Address.Street1 != null){
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.Address.Street1, 1114));
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.Address.Street2, 1115));
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.Address.City, 1116));
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.Address.State, 1117));
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.Address.Zip, 1118));
    fields.push(new DataObjectField(vData.Tenant.ContactInformation.Address.Country, 1119));
  }

  fields.push(new DataObjectField(vData.resubmissions, 741));

  const dataObject = {
    qdbapi: {
      rid: Number(vData.appid),
      udata : "EVICTION_DIVERSION_TFA_APPLICATION_RESUBMISSION",
      clist: "32",
      field: fields,
    },
  };
  return dataObject;
};

export default buildLandlordResubmissionDataObject;